import { Site } from '@envato/foundation-types'

interface INoIndexParams {
  name: string
  value?: string
}

interface INoIndexAllowList {
  site: Site
  routes: string[]
  params: INoIndexParams[]
}

interface AllowedTagsBySite {
  [site: string]: string[]
}

const allAllowedTagsBySite: AllowedTagsBySite = {
  [Site.audiojungle]: [
    '1 minute',
    '10 seconds',
    '12 days of christmas',
    '15 sec',
    '15 seconds',
    '16-bit',
    '1950s',
    '20 sec',
    '30 seconds',
    '432 hz',
    '60 seconds',
    '8 bit game over',
    '8-bit',
    '80s',
    '80s synth',
    '8k',
    '90s',
    'a.r.rahman',
    'aboriginal',
    'acapella',
    'access denied',
    'access granted',
    'advertising',
    'afro beat',
    'afrobeat',
    'aftermovie',
    'ak47',
    'akm',
    'aladdin',
    'alan walker',
    'allahu akbar',
    'anime',
    'announcer',
    'app promo',
    'arabic',
    'arabic music',
    'asmr',
    'attack on titan',
    'attitude',
    'audio branding',
    'audio jingle',
    'audio logo',
    'audio mark',
    'audiobook',
    'audiomachine',
    'auto',
    'ave maria',
    'avengers',
    'award ceremony',
    'award show',
    'awards ceremony',
    'b roll',
    'baby laughing',
    'background music',
    'backing track',
    'backsound',
    'bagpipes',
    'bali',
    'balkan',
    'bamboo flute',
    'bank robbery',
    'bansuri',
    'barry white',
    'bass boosted',
    'bass drop',
    'batman',
    'battleship',
    'beatbox',
    'belly dance',
    'bengali',
    'benny hill',
    'bgm',
    'bhangra',
    'big boss',
    'bla bla',
    'black friday',
    'blade runner',
    'bloopers',
    'bodybuilding',
    'bollywood',
    'bossanova',
    'bottle opener',
    'bow-chicka-wow-wow',
    'breakdance',
    'breaking news',
    'bruce lee',
    'build up',
    'bumper music',
    'bungee jumping',
    'burnout',
    'call of duty',
    'candy crush',
    'carillon',
    'cartoon music',
    'cartoon voice uh-oh',
    'casey neistat',
    'chariots of fire',
    'charlie chaplin',
    'child laughing',
    'chinese drum',
    'chinese new year',
    'chiptune',
    'christmas bells',
    'christmas intro',
    'christmas jazz',
    'christmas party',
    'cinderella',
    'cinematic boom',
    'cinematic horn',
    'cinematic impact',
    'cinematic intro',
    'cinematography',
    'clap',
    'clapperboard',
    'climax',
    'clint eastwood',
    'clock ticking',
    'coca cola',
    'cock crying',
    'colors',
    'comedy',
    'comedy drama',
    'commentary',
    'contact',
    'correct answer',
    'countdown',
    'crack',
    'cumbia',
    'cyberpunk',
    'daft punk',
    'dark ambient',
    'debbie downer',
    'deck the halls',
    'deep house',
    'defibrillator',
    'demo reel',
    'desi dhol beat',
    'detective',
    'dhol',
    'dholak',
    'dialogue',
    'didgeridoo',
    'disney',
    'diwali',
    'documentary',
    'doo wop',
    'drum beat',
    'drum roll',
    'drum solo',
    'drumline',
    'drums',
    'edm',
    'egyptian',
    'eid mubarak',
    'electro swing',
    'emoji',
    'emotional background',
    'enemies ahead',
    'epic',
    'epic choir',
    'epic intro',
    'epic music',
    'epic trailer music',
    'erotic',
    'eurobeat',
    'evil laugh',
    'eww',
    'explainer video',
    'fanfare',
    'fashion show',
    'fast forward',
    'female vocal',
    'female voice',
    'fight scene',
    'film noir',
    'finger snap',
    'flashback',
    'flashback sound',
    'forest',
    'frank sinatra',
    'freeze frame',
    'fruit ninja',
    'funny background music',
    'funny piano',
    'future bass',
    'gagged',
    'game music',
    'game of thrones',
    'game over sound',
    'game show',
    'gamelan',
    'genie',
    'ghostbusters',
    'ghungroo',
    'gibberish',
    'girl moaning',
    'glitch',
    'greek',
    'gregorian chant',
    'guinea+fowl+sounds',
    'gujarati',
    'hacker',
    'hallelujah',
    'hang drum',
    'hans zimmer',
    'happy birthday',
    'happy new year',
    'hard bass',
    'harley davidson',
    'harmonium',
    'harry potter',
    'hawaiian',
    'heart touching',
    'heartbeat',
    'hindi',
    'ho ho ho',
    'hologram',
    'horny',
    'horror ambience',
    'horror intro',
    'horror music',
    'horror trailer',
    'hype',
    'hyperlapse',
    'identify',
    'igtv',
    'imagine dragons',
    'indian flute',
    'indonesia',
    'infographics',
    'instrumental',
    'intro',
    'intro music',
    'islamic',
    'italian',
    'ivr',
    'james bond',
    'japanese',
    'japanese flute',
    'jeopardy',
    'jewish',
    'jingle bells',
    'jingles',
    'joker',
    'jumanji',
    'jump',
    'jump scare',
    'jungle beat',
    'junk',
    'jurassic park',
    'kaun banega crorepati',
    'kawaii',
    'keynote',
    'kinetic typography',
    'king kong',
    'korean drama',
    'korean music',
    'kpop',
    'kung fu',
    'la la la',
    'ladies and gentlemen',
    'lamborghini',
    'laugh track',
    'let it snow',
    'level complete',
    'lion dance',
    'lion roar',
    'lo-fi',
    'loading screen',
    'login',
    'logo animation',
    'logo intro',
    'logo jingle',
    'logo reveal',
    'logo sound',
    'logo sound effects',
    'logo sting',
    'love music',
    'lower third',
    'ludovico einaudi',
    'male moan',
    'man moaning',
    'man yelling stop',
    'mantra',
    'marching band',
    'mardi gras',
    'mariachi',
    'martial arts',
    'marvel',
    'match 3',
    'mexican',
    'mg42',
    'michael jackson',
    'mickey mouse',
    'midi',
    'minion',
    'minion laugh',
    'miss universe',
    'mission complete',
    'mission impossible',
    'moaning',
    'mongolian',
    'monkey',
    'monster roar',
    'montage',
    'moroccan',
    'mortal kombat',
    'motion graphics',
    'motivational speech',
    'music bundle',
    'nagada',
    'national anthem',
    'national geographic',
    'native american',
    'nba',
    'nepal',
    'new year countdown',
    'news background',
    'news headlines',
    'news intro',
    'news jingle',
    'news opener',
    'nigeria',
    'ninja',
    'notification sound',
    'nursery rhyme',
    'nutcracker',
    'ode to joy',
    'odesza',
    'oh no',
    'om',
    'opener',
    'opening ceremony',
    'opera',
    'orgasm',
    'oud',
    'outro',
    'pacman',
    'pakhawaj',
    'pakistan',
    'pan flute',
    'paparazzi',
    'pennywise',
    'people are awesome',
    'peppa pig',
    'pickaxe',
    'pingu',
    'pink floyd',
    'pink panther',
    'pirate',
    'pirates of the caribbean',
    'pixel',
    'podcast',
    'podcast intro',
    'pokemon',
    'police siren',
    'post-apocalyptic',
    'powtoon',
    'prank',
    'prize wheel',
    'product demo',
    'product launch',
    'promo',
    'punjabi',
    'puppet show',
    'puzzle game',
    'quiz',
    'radio intro',
    'radio sweeper',
    'ramadan',
    'ramadhan',
    'rap',
    'rap beat',
    'ready set go',
    'real estate',
    'reality show',
    'record scratch',
    'red carpet',
    'reggaeton',
    'reindeer',
    'remove',
    'retrowave',
    'rick ross',
    'ringtones',
    'robot walking',
    'romeo and juliet',
    'roulette wheel',
    'royal entrance',
    'sad background music',
    'sad piano',
    'sad song',
    'sad violin',
    'sam kolder',
    'samurai',
    'sandstorm',
    'santa claus voice',
    'scandinavian',
    'scooter',
    'sexy',
    'sexy sound',
    'sexy voice',
    'sfx',
    'shaman',
    'shaolin',
    'shine',
    'short film',
    'short intro',
    'showreel',
    'showtime',
    'silent hill',
    'singing bowl',
    'single gunshot',
    'sitcom',
    'sleigh bells',
    'sleigh ride',
    'slideshow',
    'slot machine',
    'slow motion',
    'snake charmer',
    'sniper rifle',
    'snoop dogg',
    'soccer',
    'sony vegas',
    'soundtrack',
    'space invaders',
    'space shooter',
    'spaghetti western',
    'spanish guitar',
    'splash screen',
    'star wars',
    'steampunk',
    'stems',
    'stinger',
    'stings',
    'stomp',
    'stomp opener',
    'stop motion',
    'stopwatch',
    'storytelling',
    'stranger things',
    'studio ghibli',
    'subscription',
    'superhero',
    'swipe',
    'sword fight',
    'synthwave',
    'tada',
    'taiko drum',
    'talk show',
    'teaser',
    'technical difficulties',
    'telenovela',
    'terminator',
    'tetris',
    'text animation',
    'thai',
    'thanksgiving',
    'thriller',
    'throat singing',
    'thug life',
    'tibetan',
    'tick tock',
    'ticking clock',
    'tik tok',
    'time passing',
    'time warp',
    'timelapse',
    'timeout',
    'tinkerbell',
    'tizer',
    'toing',
    'tom and jerry',
    'torrent',
    'touchscreen',
    'tower defense',
    'transition',
    'trap',
    'travel video',
    'tribal drums',
    'troll',
    'tron legacy',
    'turkish',
    'twinkle twinkle little star',
    'two steps from hell',
    'unboxing',
    'upbeat drums',
    'upload',
    'vibrator',
    'video',
    'viking',
    'villain',
    'vlog intro',
    'vlogging',
    'voiceover',
    'volleyball',
    'war drums',
    'water drop',
    'watermark',
    'we will rock you',
    'weather forecast',
    'weather intro',
    'wedding invitation',
    'wedding march',
    'wedding music',
    'wedding song',
    'wheel of fortune',
    'whisper',
    'whistle',
    'who wants to be a millionaire',
    'winner announcement',
    'winter wonderland',
    'wolf whistle',
    'woman moaning',
    'woman panting',
    'woohoo',
    'world of warcraft',
    'wrong answer',
    'wwe',
    'xenomorph',
    'xylophone',
    'yay',
    'youtube',
    'youtube intro',
    'yum'
  ],

  [Site.codecanyon]: [
    '123movies',
    '360 virtual tour',
    '3d slider',
    '8 ball pool',
    '9gag clone',
    'accounting',
    'accounting software',
    'adf.ly',
    'admin panel',
    'admin template',
    'admob',
    'advertising',
    'affiliate',
    'affiliate marketing',
    'airbnb',
    'airport shuttle',
    'alibaba',
    'alidropship',
    'aliexpress',
    'amazon affiliate',
    'amazon dropship',
    'android app',
    'android game',
    'android source code',
    'android studio',
    'android tv',
    'android webview',
    'angularjs',
    'animated background',
    'animated icons',
    'animated menu',
    'animation',
    'antivirus',
    'apartment rental',
    'apk download',
    'app builder',
    'artificial intelligence',
    'asp.net',
    'astrology',
    'audiobook',
    'auto repair',
    'autoblog',
    'avia builder',
    'backlink',
    'badoo',
    'bank transfer',
    'banner',
    'barcode scanner',
    'best school management system',
    'betting',
    'bigbasket clone',
    'bingo',
    'bit.ly',
    'bitcoin',
    'bitcoin wallet',
    'bkash payment gateway',
    'blablacar clone',
    'black friday',
    'blockchain',
    'blogger',
    'booking',
    'booking app full source code',
    'booking calendar',
    'booking system',
    'bookmyshow clone script',
    'breaking news',
    'breaking news ticker',
    'brochure',
    'browser game',
    'buddypress',
    'buildbox',
    'buildbox game template',
    'buildbox template',
    'bulk email sender',
    'bulk sms',
    'bus booking system open source',
    'bus reservation system',
    'bus seat booking code in php',
    'business',
    'business card',
    'business card design plugin',
    'business directory',
    'buzzfeed clone',
    'calculator',
    'calendar',
    'candy crush saga',
    'canva clone',
    'canvas',
    'card game',
    'card slider',
    'cash on delivery',
    'casino',
    'category filter',
    'charity',
    'chat',
    'chat app',
    'chat bot',
    'chatroom',
    'chess',
    'christmas',
    'christmas card',
    'church app',
    'classified',
    'classified ads',
    'client management',
    'client portal',
    'cms',
    'codeigniter',
    'codeigniter admin panel',
    'codeigniter pos',
    'codeigniter school management system',
    'college management system',
    'coloring book',
    'community',
    'construct 2',
    'construct 3',
    'contact form 7',
    'contact form 7 payment gateway',
    'contact us',
    'content locker',
    'contest',
    'convert website to app',
    'cordova',
    'cost calculator',
    'countup',
    'coupon',
    'courier',
    'crack',
    'cricbuzz',
    'cricket betting',
    'crm',
    'crossword',
    'crowdfunding',
    'crypto',
    'cryptocurrency',
    'currency converter',
    'cursor',
    'custom phone case',
    'custom t shirt design maker',
    'custom tailored suits online',
    'customer support',
    'dashboard',
    'dating',
    'dating app',
    'dating script',
    'dialogflow',
    'dictionary',
    'doctor appointment',
    'doctor directory',
    'dogecoin',
    'dokan',
    'donation script',
    'downloads',
    'drawing',
    'dream11',
    'dream11 clone cricket script',
    'dropshipping',
    'e-learning',
    'e-wallet',
    'ebay',
    'ebook',
    'ecard',
    'ecommerce',
    'ecommerce app',
    'ecommerce website',
    'education app',
    'elearning',
    'elementor',
    'email builder',
    'email marketing',
    'email template builder',
    'employee management',
    'employee management system',
    'epaper',
    'erp',
    'ethereum',
    'event booking',
    'event calendar',
    'event management',
    'eventbrite',
    'eventbrite clone',
    'exam admit card generator',
    'excel',
    'expense manager',
    'facebook',
    'facebook clone',
    'facebook quiz',
    'facebook video downloader',
    'fake traffic generator',
    'faq',
    'fembed',
    'ffmpeg',
    'file manager',
    'file sharing',
    'file upload',
    'fitness',
    'fiverr',
    'fiverr clone',
    'flaticon',
    'flip book',
    'flipbook',
    'floor plan',
    'floorplan',
    'flutter',
    'flyer design',
    'food delivery app',
    'food ordering',
    'foodpanda clone',
    'forex',
    'forex signal',
    'form builder',
    'form builder open source',
    'fortnite',
    'forum',
    'frame',
    'free fire',
    'freelancer',
    'frontend dashboard',
    'gambling',
    'game',
    'geolocation',
    'gform',
    'gif',
    'gift card',
    'gojek',
    'gold price',
    'google clone',
    'google drive',
    'google maps',
    'google web designer',
    'gravity forms',
    'greeting card',
    'grocery',
    'grocery app',
    'grofers clone',
    'groupon',
    'gsap',
    'hack',
    'happy birthday',
    'health',
    'helix jump',
    'helpdesk',
    'homeadvisor clone',
    'horizontal menu',
    'hospital',
    'hospital management system',
    'hotel booking',
    'hotel management',
    'housing society management',
    'hrms',
    'html',
    'html5 game',
    'hybrid',
    'hyip',
    'hyip monitor',
    'ibilling',
    'icon pack',
    'image editor',
    'image upload',
    'imdb',
    'indeed',
    'instagram',
    'instagram analytics',
    'instagram clone',
    'instagram downloader',
    'instagram feed',
    'interactive map',
    'intranet',
    'inventory management',
    'investment',
    'invoice',
    'invoice generator',
    'ionic',
    'ionic 3',
    'ip tv',
    'iptv',
    'jackpot',
    'java',
    'javascript t-shirt designer',
    'job board',
    'job portal',
    'jquery chat',
    'jquery organization chart',
    'jumia wordpress',
    'justdial',
    'kanban',
    'kiosk',
    'knowledge base',
    'kotlin',
    'landing page',
    'laravel',
    'laravel admin',
    'laravel crm',
    'laravel ecommerce',
    'laundry',
    'lawyer',
    'lead management',
    'lead management system',
    'leaderboard',
    'learning management system',
    'lending',
    'library management system',
    'linkedin',
    'linktree',
    'listing app',
    'live chat',
    'live stream',
    'live streaming',
    'live tv',
    'lms',
    'loan management system',
    'login',
    'logo maker',
    'lottery',
    'lottie',
    'ludo game',
    'lyrics',
    'magazine',
    'mailwizz',
    'manga reader',
    'mapbox',
    'marketplace',
    'marquee',
    'material design',
    'mcq',
    'medical',
    'medical store software php. open source pharmacy software',
    'mega menu',
    'meme generator',
    'memory game',
    'menu',
    'merry christmas',
    'messenger',
    'messenger bot',
    'mlm',
    'mlm software',
    'mobile app',
    'mobile game',
    'mobile phone case design',
    'mobile recharge',
    'mockup',
    'model agency',
    'modern',
    'movie cms',
    'movie script',
    'movie streaming',
    'movie ticket booking android app source code',
    'mp3',
    'multiple choice',
    'music app',
    'music charts',
    'netflix',
    'netflix clone',
    'new year',
    'news app',
    'news script',
    'newsletter',
    'newspaper',
    'nodejs',
    'ocr',
    'office management',
    'ola clone',
    'olx',
    'olx clone',
    'onetap',
    'online blood donation',
    'online booking',
    'online course',
    'online exam',
    'online game',
    'online movie ticket booking project in php',
    'online news portal',
    'online photo editor',
    'online quiz',
    'online shop',
    'online tv',
    'onlyfans',
    'onlyfans clone',
    'onsen ui',
    'open source hospital management system',
    'open source php online exam system',
    'opening hours',
    'openload',
    'order management',
    'order tracking',
    'organic traffic bot',
    'otp',
    'otp login signup',
    'oxoo',
    'particle effect',
    'particle js',
    'patreon clone',
    'paxful',
    'payment gateway',
    'paypal',
    'paytm clone',
    'pdf viewer',
    'pdf viewer for php website',
    'personal trainer',
    'personality tests',
    'pharmacy',
    'pharmacy management system',
    'photo editor',
    'photo editor sdk',
    'photo sharing',
    'photography',
    'php',
    'php chat',
    'php crud',
    'php pos',
    'php video script',
    'phpmaker',
    'phpmyadmin',
    'pinterest',
    'podcast',
    'poker',
    'popup',
    'portfolio',
    'portfolio slider',
    'pos',
    'pos system',
    'post filter',
    'practo clone app',
    'prescription',
    'price comparison',
    'pricing slider',
    'pricing table',
    'product builder',
    'product configurator',
    'product customization',
    'product designer',
    'product filter',
    'product slider',
    'property management',
    'ptc',
    'pubg mobile',
    'pubg tournament app',
    'purchase code',
    'pwa',
    'python',
    'qr code',
    'qr code scanner',
    'quiz',
    'quiz app',
    'quora clone',
    'quote form',
    'quote generator',
    'quotes',
    'quran',
    'racing game',
    'radio app',
    'radio station',
    'raffle',
    'razorpay',
    'react',
    'react native',
    'react-native',
    'real estate',
    'real estate script',
    'recent sales popup',
    'recharge',
    'redbus clone',
    'redeem',
    'referral',
    'remove background',
    'reseller',
    'reskin',
    'responsive menu',
    'rest api',
    'restaurant app',
    'restaurant pos',
    'resume builder',
    'reviews',
    'rewards app',
    'roulette',
    'saas',
    'santa claus',
    'sap',
    'schoex',
    'school erp',
    'school management system',
    'scraper',
    'scratch card',
    'seat booking',
    'sell',
    'seo',
    'seo tool',
    'server monitor',
    'shipping calculator',
    'shopify',
    'shopping list',
    'shoutbox',
    'sidebar menu',
    'slither',
    'slither.io',
    'slot machine',
    'smm panel',
    'snapchat',
    'snaptube',
    'sngine',
    'snow',
    'social network',
    'social network script',
    'soundcloud clone',
    'source code',
    'speed test',
    'splash screen',
    'spotify',
    'spotify clone',
    'statistics',
    'stick hero',
    'sticky footer',
    'stock market',
    'store management',
    'student management system',
    'suitecrm',
    'survey',
    'svg map',
    'swift',
    'swiggy',
    'swiggy clone',
    't-shirt designer',
    't-shirt ecommerce',
    'table',
    'tarot',
    'task management',
    'task manager',
    'task rabbit clone',
    'taxi app',
    'taxi booking',
    'team',
    'telegram',
    'telegram clone',
    'temple run',
    'testimonials',
    'text to speech',
    'thisiswhyimbroke clone',
    'three js',
    'tiktok',
    'tiktok clone',
    'tiktok video downloader',
    'time killer',
    'timesheet',
    'timetable',
    'tinder',
    'tmdb',
    'todo list',
    'tools',
    'tour package',
    'tournament',
    'trade',
    'trading',
    'travel agency',
    'tshirt ecommerce',
    'twitch',
    'twitter',
    'two-factor authentication',
    'uber',
    'uber clone',
    'ubereats clone script',
    'udemy',
    'unity',
    'uptime',
    'urbanclap clone',
    'url shortener',
    'url shortener script',
    'user profile',
    'valentine',
    'vcard',
    'venmo',
    'vertical tabs',
    'viber',
    'video',
    'video call',
    'video cms',
    'video downloader',
    'video editor',
    'video gallery',
    'video streaming',
    'video subscription platform',
    'video upload',
    'vidmate',
    'vin decoder',
    'virtual mirror',
    'virtual tour',
    'voting',
    'vpn',
    'wallet',
    'wallpaper',
    'wallpaper app',
    'webcam',
    'website builder',
    'website monitoring',
    'website traffic generator',
    'webview',
    'whatsapp',
    'whatsapp chat',
    'whatsapp clone',
    'whatsapp form',
    'whatsapp status',
    'whatsapp status downloader',
    'whatsapp status video odia',
    'wheel',
    'wheel of fortune',
    'whmcs',
    'wiki',
    'woocommerce',
    'woocommerce app',
    'woocommerce cart',
    'woocommerce checkout',
    'woocommerce coupons',
    'woocommerce embed videos to product image gallery',
    'woocommerce flash sale',
    'woocommerce food delivery',
    'woocommerce gallery',
    'woocommerce product calculator',
    'woocommerce rest api',
    'woocommerce sold out badge',
    'woocommerce supplier',
    'wordpress game',
    'wowonder',
    'wp newz nulled',
    'xamarin',
    'yelp clone',
    'youtube',
    'youtube clone',
    'youtube downloader',
    'youtube subscribers',
    'youtube video downloader script',
    'zomato clone'
  ],

  [Site.photodune]: [
    'action',
    'adalt',
    'agronomist',
    'aikido',
    'amsterdam canal houses',
    'animals',
    'apocalypse',
    'apocalyptic',
    'application',
    'applying',
    'arms wide spread',
    'asian ethnicity',
    'ayurveda',
    'ayurveda',
    'ayurvedic',
    'background',
    'backlighting',
    'bahrain',
    'bakalaw',
    'ballet',
    'bangladeshi',
    'bed',
    'best',
    'billed',
    'bird of pray',
    'biro yorkshire terrier',
    'bite',
    'black',
    'blueberry',
    'blur',
    'bondage',
    'booty',
    'bottomless',
    'box',
    'burnt',
    'business',
    'business meeting',
    'butt',
    'buttocks',
    'bveak',
    'calendar',
    'candid',
    'candy cane',
    'cane corso',
    'carronts',
    'casual clothing',
    'cavalier king charles spaniel',
    'centaurea cyanus',
    'chabo',
    'cheesy',
    'chicory',
    'chili peppers',
    'chinese new year',
    'chubby',
    'cosmetic surgery',
    'elements',
    'erotic',
    'farm worker',
    'fashion model',
    'frontal',
    'girls in bed',
    'granny',
    'habrchad',
    'inga',
    'jokulsarlon lagoon',
    'lingerie',
    'logo',
    'mature women',
    'numida meleagris',
    'panties',
    'pantyhose',
    'pasta',
    'pata rat',
    'payment',
    'people',
    'physical therapy',
    'plasma ball',
    'selling',
    'sexy',
    'shell',
    'site',
    'social media',
    'sparkler',
    'submit',
    'subscription',
    'sunscreen',
    'support',
    'template',
    'theme',
    'tiger cub',
    'topless',
    'torrent',
    'toychik',
    'udelo',
    'undressed',
    'upload'
  ],

  [Site.threedocean]: [
    '3d panic bar',
    '4k',
    '4k seamless textures',
    'adidas',
    'adolf hitler',
    'aid',
    'airpod case',
    'airpods',
    'airstream',
    'ak47',
    'allium',
    'almond',
    'alphabet',
    'anaconda',
    'anglerfish',
    'anime',
    'antenna',
    'aquiles adrianza',
    'arab',
    'arabic',
    'ashley furniture',
    'astronaut',
    'astroturf',
    'audi r8',
    'awning',
    'backpack',
    'backplate',
    'bacteria',
    'bags',
    'baguette',
    'bakery',
    'balloon',
    'balloon gate',
    'bambina',
    'bamboo',
    'bananas',
    'bandaid',
    'base mesh',
    'baseball jersey',
    'batman',
    'battleship',
    'baxter',
    'bazaar',
    'bazooka',
    'bb8',
    'beanstalk',
    'beard',
    'bebo',
    'beer',
    'beer bottle',
    'beret',
    'bikini',
    'billboard',
    'birch',
    'blazblue',
    'bleach',
    'blister',
    'bmw',
    'bmw 1 series',
    'bmw 2',
    'bmw 4 series',
    'bmw e30',
    'bmw i3',
    'boca do lobo',
    'bodybuilder',
    'bookcase',
    'boombox',
    'boots',
    'bougainvillea',
    'boy',
    'brain',
    'bread',
    'breast',
    'bugatti',
    'buoy',
    'burger',
    'busty',
    'cactus',
    'cadillac',
    'cake',
    'car mr bean',
    'casino',
    'cassette',
    'cat',
    'cauldron',
    'caustics',
    'cbr',
    'cement bag',
    'cendres',
    'cheese',
    'cherry',
    'chibi',
    'chicken',
    'chips',
    'chocolate',
    'cigarette',
    'circus',
    'clash of clans',
    'clash royale',
    'claw',
    'clay',
    'clo3d',
    'cloak',
    'coal',
    'coca cola',
    'coconut',
    'coffee bean',
    'coffin',
    'concert',
    'concert stage',
    'condensation',
    'confetti',
    'continents',
    'corduroy',
    'corona renderer',
    'corpse',
    'cosmetics',
    'cosmos',
    'cotton',
    'cow',
    'cowboy',
    'cracked',
    'cracks',
    'cricket',
    'cricket ball',
    'crisps',
    'crocodile',
    'crystal',
    'cubemap',
    'cupcake',
    'dandelion',
    'desert eagle',
    'destroyed',
    'diaper',
    'dollar',
    'donut',
    'dragon',
    'drinking straw',
    'dropper',
    'dropper bottle',
    'ducato',
    'duck',
    'dxracer',
    'dystopian',
    'e-tron',
    'e46',
    'earth',
    'easel',
    'ecchi',
    'egypt',
    'egyptian',
    'element 3d',
    'element 3d basketball',
    'emerald',
    'emoji',
    'empty room',
    'energy drink obj',
    'envelope',
    'environment',
    'erotic',
    'ertiga',
    'exhibition stall',
    'exhibition stand',
    'f-16',
    'f-22 raptor',
    'f35',
    'facade',
    'fanoos',
    'fat',
    'feather',
    'feet',
    'fiat tipo',
    'fido dido',
    'fifa',
    'fireman',
    'firewood',
    'fj40',
    'flags',
    'float',
    'floating',
    'flowers',
    'fluid splash',
    'foam',
    'foam rubber',
    'football',
    'fort',
    'fountain',
    'freightliner m2',
    'french fries',
    'fruit',
    'furry',
    'g-class',
    'gazelle',
    'geode',
    'gfx',
    'gingerbread',
    'giraffe',
    'globe',
    'glock',
    'goat',
    'golden',
    'gorilla',
    'grader',
    'graffiti',
    'grass',
    'guitar',
    'gums',
    'haircut',
    'hairdresser',
    'hairstyle',
    'ham',
    'hamburger',
    'hamster',
    'harbor',
    'haystack',
    'hdr',
    'hdri',
    'hdri cartoon',
    'helipad',
    'hentai',
    'hiace',
    'high heels',
    'hijab',
    'hockey',
    'horn',
    'horror',
    'hot tub spa',
    'hoverboard',
    'hulk',
    'human skin',
    'ice cream',
    'ice cream cone',
    'iceberg',
    'icing',
    'imvu',
    'inspector gadget',
    'instagram',
    'interior 3d scene',
    'iphone 6',
    'iphone x',
    'iris',
    'iron man',
    'islamic',
    'isometric',
    'isuzu d-max',
    'iveco',
    'ivy',
    'jade',
    'jeans',
    'jeep wrangler',
    'jelly',
    'jesus',
    'jewelry',
    'jupiter',
    'karim rashid',
    'kart',
    'kebab',
    'ketupat',
    'kfc',
    'kiosk',
    'kitt',
    'kitten',
    'knot',
    'koenigsegg',
    'konark sun temple',
    'kremlin',
    'kufi',
    'kuwait',
    'ladybug',
    'lamborghini',
    'lantern',
    'lego',
    'lemon',
    'lemur',
    'lettuce',
    'lib4d',
    'lightbox',
    'limestone',
    'lion',
    'lips',
    'lizard',
    'lotus esprit',
    'louisiana superdome',
    'low poly building',
    'low poly car',
    'lowpoly earth',
    'luster',
    'mannequin',
    'marvel',
    'maserati',
    'maserati granturismo',
    'maserati levante',
    'mask',
    'mcdonalds',
    'meat',
    'mecha',
    'mercedes-benz sprinter',
    'merry christmas',
    'microphone',
    'milk',
    'minecraft',
    'mini cooper',
    'minotti',
    'missile',
    'mistletoe',
    'mitsubishi fuso',
    'mitsubishi outlander',
    'mock-up',
    'mockup',
    'model x',
    'monkey',
    'monster energy',
    'monster energy 3d model obj',
    'mosaic',
    'mosque',
    'mpt-76',
    'mulch',
    'multitexture',
    'muscles',
    'mushroom',
    'mustache',
    'narbutas',
    'naruto',
    'nature',
    'nebula',
    'necromancy',
    'negligee',
    'neoclassical',
    'noodle',
    'noose',
    'npc',
    'octane render',
    'offshore platform',
    'onion',
    'opel astra',
    'opel calibra',
    'oreo',
    'pac-man',
    'pack',
    'packaging',
    'palm tree',
    'parachute',
    'parasol',
    'pasta',
    'paw-patrol',
    'peach',
    'pears',
    'pepsi',
    'perforated',
    'pergola',
    'perodua myvi',
    'petal',
    'peterbilt',
    'pharmacy',
    'photobook',
    'pierce',
    'pills',
    'pineapple',
    'pirate ship',
    'piston',
    'pitbull',
    'planet earth',
    'plant',
    'plastic chair',
    'playground',
    'plumeria',
    'plush',
    'plywood',
    'podium',
    'poliform',
    'popcorn',
    'porsche 911',
    'post apocalyptic',
    'post-apocalypse',
    'poster',
    'prado',
    'prison',
    'protein',
    'pubg',
    'pumpkin',
    'queens blade',
    'qutub minar',
    'racetrack',
    'racing car',
    'ramadan',
    'range rover',
    'realflow',
    'refinery',
    'refrigerator',
    'reindeer',
    'renault clio',
    'ribbon',
    'rigged',
    'rigged low poly soldier',
    'ripstop',
    'roll-up',
    'rolls royce',
    'rooster',
    'rope',
    'rts',
    'rug',
    'rust',
    'sachet',
    'sack',
    'samsung galaxy s10 after effects model',
    'samurai',
    'sand',
    'sanitary napkin',
    'saree',
    'satellite',
    'saturn',
    'sax',
    'scania',
    'scat',
    'sclera',
    'scooter',
    'seaweed',
    'sell',
    'sexy',
    'shader',
    'shark',
    'sheepskin',
    'shelter',
    'shipping container',
    'shopping mall',
    'sidewalk',
    'signboard',
    'skate',
    'sketchup',
    'skybox',
    'skydome',
    'slums',
    'smiley',
    'smoke',
    'snack',
    'snowflake',
    'social media',
    'softbox',
    'sombrero',
    'spaceship',
    'spaghetti',
    'spear',
    'ssangyong',
    'stage design',
    'star field',
    'starbucks',
    'steak',
    'steampunk',
    'stomach',
    'straw',
    'strawberry',
    'streetwear',
    'stucco',
    'subaru',
    'sunflower',
    'superhero',
    'superman',
    'supplement bottle',
    'suzuki',
    'suzuki jimny',
    'swimsuit',
    'syringe',
    't pose',
    't-shirt',
    'tahrir square',
    'tamiya',
    'tavern',
    'taxi',
    'temple run',
    'tent',
    'tentacle',
    'terrorist',
    'tie fighter',
    'tiger',
    'tiramisu',
    'tire',
    'tomato',
    'tombstone',
    'toyota coaster',
    'toyota corolla',
    'toyota hiace',
    'toyota hilux',
    'toyota land cruiser',
    'toyota mirai',
    'toyota vellfire',
    'toyota yaris',
    'trade show',
    'train station',
    'transformer',
    'trash can',
    'trophies',
    'trophy',
    'truss',
    'tumbleweed',
    'turri',
    'ufo',
    'underwater',
    'underwear',
    'vampire',
    'veins',
    'vespa',
    'vinyl',
    'volcano',
    'volkswagen crafter',
    'volkswagen passat',
    'volkswagen transporter',
    'volleyball',
    'vondom',
    'vray',
    'walnut',
    'watermelon',
    'whale',
    'wheat',
    'whiskey',
    'wig',
    'wine bottle',
    'wool',
    'world cup',
    'world map',
    'yamaha',
    'yellow',
    'young',
    'zafira',
    'zoid',
    'zombie'
  ],

  [Site.videohive]: [
    '120fps',
    '2d animation',
    '3d animation',
    '3d city',
    '3d logo',
    '3d text',
    '3d virtual set',
    '4k',
    '8-bit',
    '80s',
    '8bit',
    '90s',
    'adalt',
    'adobe premiere',
    'adulat',
    'advertising',
    'after effects plugins',
    'airplane',
    'airport',
    'alpha channel',
    'animated elements',
    'animated icons',
    'animated lower third',
    'animation kit',
    'animation studio',
    'anime',
    'anniversary',
    'app mockup',
    'app promotion',
    'arabic',
    'architecture',
    'army',
    'arrow',
    'artificial intelligence',
    'astrology',
    'audio spectrum',
    'audio visualization',
    'awards ceremony',
    'baby shower',
    'back to the future',
    'backside',
    'banner',
    'bathing',
    'bbw',
    'beaf',
    'beautiful girl',
    'beauty',
    'beauty salon',
    'bee',
    'beg',
    'black friday',
    'boke',
    'bokeh overlay',
    'boken',
    'bokeo',
    'bolu',
    'boor',
    'born',
    'bottle',
    'boxing',
    'brazier',
    'breaking news',
    'brest',
    'brochure',
    'broken glass',
    'bubbles',
    'bubs',
    'bullet',
    'bumper',
    'bur',
    'busty',
    'butterfly',
    'cake',
    'calendar',
    'calendar animation',
    'callout',
    'capbarista',
    'car',
    'carnival',
    'cartoon',
    'chalkboard',
    'champions league',
    'character animation',
    'chinese',
    'christmas',
    'christmas animation',
    'christmas card',
    'christmas greetings',
    'christmas intro',
    'christmas loop',
    'christmas transition',
    'christmas tree',
    'church',
    'cinematic intro',
    'cloth',
    'coffee',
    'coffee shop',
    'collage',
    'comic book',
    'coming soon',
    'company profile',
    'computer',
    'confetti',
    'cooking',
    'cooking show',
    'corporate presentation',
    'cosmetics',
    'counter',
    'crack',
    'cricket',
    'crime',
    'crot',
    'curtain',
    'cv',
    'cyberpunk',
    'defoliation',
    'deformation',
    'demo reel',
    'dentist',
    'digital background',
    'digital signage',
    'disney',
    'dj',
    'doodle',
    'dragon',
    'drone',
    'e-commerce',
    'e-learning',
    'eagle',
    'education',
    'election',
    'emoji',
    'ending',
    'engagement',
    'envelope',
    'equalizer',
    'erotic',
    'event promo',
    'evento',
    'explainer',
    'explainer toolkit',
    'explainer video',
    'facebook',
    'farewell',
    'fast food',
    'fcpx',
    'film intro',
    'finance',
    'fire effect',
    'fireworks',
    'first birthday',
    'flash fx',
    'flashback',
    'football',
    'football intro',
    'footsie',
    'foreplay',
    'forest',
    'freeze frame',
    'fron',
    'funky',
    'funny',
    'furniture',
    'fussy',
    'futuristic',
    'game intro',
    'game of thrones',
    'ganesha',
    'gatsby',
    'gfx',
    'gif',
    'gift box',
    'glitch',
    'glitch intro',
    'glitter',
    'gold logo',
    'graffiti',
    'graphic design',
    'greeting card',
    'gym',
    'hack',
    'hacking',
    'hand drawn',
    'handwriting',
    'handy seamless transitions',
    'happy birthday',
    'happy christmas gift',
    'happy new year',
    'happy new year',
    'hardcord',
    'harry potter',
    'heart',
    'heartbeat',
    'hip hop',
    'holi',
    'hologram',
    'honeymoon',
    'horror',
    'hot hub',
    'hud',
    'hud elements',
    'hype',
    'igtv',
    'india',
    'ink transition',
    'instagram stories',
    'interior design',
    'interview',
    'intro',
    'iphone 11',
    'iphone mockup',
    'iron man',
    'islamic',
    'isometric',
    'japan',
    'javanese',
    'jewelry',
    'jungle',
    'kaleidoscope',
    'karaoke',
    'keynote',
    'kids',
    'kinetic typography',
    'kitchen',
    'laptop',
    'led screen',
    'lion',
    'login',
    'logistics',
    'logo animation',
    'logo intro',
    'logo opener',
    'logo reveal',
    'logo transition',
    'lomo',
    'love',
    'love story',
    'lovers day',
    'lyrics',
    'macbook',
    'makeup',
    'manga',
    'marvel',
    'masala',
    'matrix',
    'meme',
    'merry christmas',
    'military',
    'mini bikini',
    'mission impossible',
    'mma',
    'mobile app',
    'mockup',
    'mogrt',
    'money',
    'montage',
    'morph',
    'mosaic',
    'motion bro',
    'motion factory',
    'motorcycle',
    'mouse sesi',
    'movie trailer',
    'multi screen',
    'music',
    'music visualization',
    'music visualizer',
    'navidad',
    'neon',
    'new year',
    'new year countdown',
    'news intro',
    'news opener',
    'newspaper',
    'nide',
    'night club',
    'nomination',
    'onlain',
    'opener',
    'opening',
    'origami',
    'outro',
    'page turn',
    'pantyhose',
    'parallax',
    'peon',
    'peron',
    'photo album',
    'photo animation',
    'photo collage',
    'photo gallery',
    'photo template',
    'pinnacle',
    'pion',
    'pirate',
    'pizza',
    'playing cards',
    'png',
    'poking',
    'polaroid',
    'police',
    'pom',
    'pone',
    'pont',
    'pop art',
    'pore',
    'poster',
    'powerpoint',
    'premiere pro',
    'presentation',
    'preset',
    'privat',
    'product launch',
    'progress bar',
    'projection mapping',
    'promo',
    'prone',
    'prun',
    'psd templates',
    'pubg',
    'puck',
    'puzzle',
    'quiz',
    'racing',
    'rap',
    'rapa',
    'reaf',
    'real estate',
    'reap',
    'red carpet',
    'reflections',
    'reps',
    'resolume',
    'retro',
    'ribbon',
    'ripe',
    'robot',
    'rocket',
    'romance',
    'romantic massage',
    'sace',
    'sacs',
    'same-sex',
    'santa claus',
    'save the date',
    'sax',
    'saxo',
    'scribble',
    'scy',
    'seductive',
    'sell',
    'sew',
    'sexual',
    'sexy promo',
    'sexy woman',
    'sfx',
    'shear',
    'showreel',
    'skis',
    'slideshow',
    'slot machine',
    'smoke',
    'snapchat',
    'snow',
    'snow transition',
    'social media',
    'sparkle',
    'speedometer',
    'splatter',
    'sport promo',
    'sports intro',
    'sss',
    'star wars',
    'statistics',
    'stickman',
    'stinger',
    'stomp',
    'stop motion',
    'streaptease',
    'stripper',
    'subscribe',
    'subscription',
    'superheroine',
    'supermarket',
    'sweety',
    'swipe up',
    'synthwave',
    't-shirt mock up',
    'talk show',
    'taxi',
    'team',
    'teaser',
    'teenager',
    'tempting',
    'text animation',
    'text effects',
    'text presets',
    'thank you',
    'thanksgiving',
    'time travel',
    'timeline',
    'title animation',
    'toon',
    'torn paper',
    'torrent',
    'transformers',
    'travel',
    'travel agency',
    'travel intro',
    'tv intro',
    'tv studio background',
    'twitch',
    'typewriter',
    'ui',
    'valentine',
    'vaporwave',
    'vertical',
    'vfx',
    'videowall',
    'vintage',
    'vinyl',
    'virtual reality',
    'virtual studio',
    'vj loops',
    'vlog',
    'vlog intro',
    'vodeo',
    'walk cycle',
    'wap',
    'water splash',
    'watercolor',
    'waterfall',
    'waveform',
    'weather forecast',
    'web design',
    'website intro',
    'wedding background',
    'wedding intro',
    'wedding invitation',
    'wedding pack',
    'wedding title',
    'western',
    'world map',
    'wrestling',
    'ww',
    'xmas',
    'youtube',
    'youtube intro'
  ],
  [Site.themeforest]: [
    '3d',
    'about us',
    'academic',
    'academy',
    'accessibility-ready',
    'accounting',
    'admin',
    'admin dashboard',
    'admin dashboard template',
    'admin panel',
    'admin template',
    'ads',
    'adsense',
    'advanced search',
    'advertising',
    'agency',
    'agriculture',
    'air conditioning',
    'airbnb',
    'ajax',
    'amazon affiliate',
    'amazon like',
    'amp',
    'analytics',
    'android',
    'android app',
    'angular',
    'angular 6',
    'angular 7',
    'angular 8',
    'angular 9',
    'angular admin',
    'angular app',
    'angular bootstrap',
    'angular dashboard',
    'angular ecommerce',
    'angular landing page',
    'angular material',
    'angularjs',
    'animated',
    'animation',
    'ant design',
    'api doc',
    'app',
    'app design',
    'app landing',
    'app landing page',
    'app presentation',
    'app showcase',
    'app store',
    'app template',
    'appliance repair',
    'application',
    'appointment',
    'arabic',
    'architect',
    'architecture',
    'art gallery',
    'article',
    'article wordpress',
    'artist portfolio',
    'association',
    'astrology',
    'auto dealer',
    'auto parts',
    'auto repair',
    'automotive',
    'baby',
    'backend',
    'background video',
    'backoffice',
    'bakery',
    'bank',
    'banking',
    'banners',
    'bar',
    'barbershop',
    'basketball',
    'bbpress',
    'beautiful',
    'beauty',
    'beauty products',
    'beauty salon',
    'bed and breakfast',
    'behance',
    'bike',
    'biography',
    'birthday',
    'black',
    'black friday',
    'blockchain',
    'blog',
    'blog design',
    'blog html',
    'blood donation',
    'blue',
    'book',
    'book store',
    'booking',
    'booking calendar',
    'bootstrap',
    'bootstrap 3',
    'bootstrap 4',
    'bootstrap 4 admin',
    'bootstrap 4 template',
    'bootstrap admin',
    'bootstrap dashboard',
    'bootstrap social network',
    'bootstrap vue',
    'boutique',
    'brand store',
    'bulma',
    'burger',
    'business',
    'business consulting',
    'business directory',
    'business portfolio',
    'buy sell',
    'cake',
    'cake shop',
    'candidate',
    'car dealer',
    'car rental',
    'car repair',
    'car service',
    'car wash',
    'career',
    'cargo',
    'carousel',
    'cars',
    'case study',
    'catalog',
    'catering',
    'cctv',
    'chat',
    'chatbot',
    'checkout',
    'christmas',
    'cinema',
    'city',
    'classified',
    'classified ads',
    'classifieds',
    'clean',
    'cleaning',
    'cleaning company',
    'cleaning service',
    'client',
    'clinic',
    'clothes store',
    'clothing',
    'club',
    'cms',
    'coach',
    'coaching',
    'code',
    'coffee',
    'coffee shop',
    'college',
    'coming soon',
    'community',
    'company portfolio',
    'company profile',
    'compare',
    'competition',
    'computer repair',
    'conference',
    'constant contact',
    'construction',
    'construction company',
    'construction html',
    'consultancy',
    'contact form',
    'contractor',
    'coronavirus',
    'corporate',
    'cosmetics',
    'counseling',
    'countdown',
    'coupon',
    'coupon codes',
    'courier',
    'course',
    'courses',
    'covid-19',
    'coworking',
    'cpanel',
    'creative agency',
    'creative portfolio',
    'cricket',
    'crm',
    'crowdfunding',
    'crud',
    'crypto',
    'cryptocurrency',
    'css',
    'css3',
    'currency exchange',
    'customer support',
    'customizable',
    'cv',
    'cyber security',
    'dance',
    'dance studio',
    'dark',
    'dark mode',
    'dashboard',
    'dashboard template',
    'database',
    'dating',
    'decoration',
    'delivery',
    'delivery service',
    'demo',
    'dental clinic',
    'dentist',
    'design',
    'design agency',
    'design studio',
    'designer portfolio',
    'developer',
    'digital agency',
    'digital marketing',
    'digital marketing agency',
    'digital products',
    'directory',
    'directory listing',
    'dj',
    'dj portfolio',
    'doctor',
    'doctor appointment',
    'doctors',
    'documentation',
    'documentation template',
    'dog',
    'dokan',
    'domain for sale',
    'domain sale',
    'donation',
    'donation website template',
    'driving school',
    'drupal 8',
    'dry fruits',
    'e-commerce',
    'e-learning',
    'ebook',
    'ebook landing page',
    'ecommerce',
    'ecommerce dashboard',
    'ecommerce html',
    'ecommerce psd',
    'education',
    'education landing page',
    'elearning',
    'electrical',
    'electronics',
    'electronics store',
    'elegant',
    'element ui',
    'elementor',
    'elements',
    'email notification',
    'erp',
    'escort',
    'esports',
    'event',
    'event calendar',
    'event landing page',
    'event management',
    'event planner',
    'event website',
    'facebook',
    'facebook style',
    'factory',
    'faq',
    'farm',
    'fashion',
    'fashion blog',
    'fashion store',
    'fast',
    'fast loading',
    'feminine',
    'festival',
    'figma',
    'finance',
    'fintech',
    'fishing',
    'fitness',
    'fiverr',
    'flat',
    'flexbox',
    'flight',
    'flipbook',
    'flipkart like',
    'flooring',
    'flower shop',
    'food',
    'food blog',
    'food delivery',
    'food menu',
    'football',
    'football club',
    'forms',
    'forum',
    'foundation',
    'framework7',
    'freelancer',
    'freelancer portfolio',
    'freight',
    'frontend',
    'fruits and vegetables',
    'fullscreen',
    'fullscreen slider',
    'fundraising',
    'funeral',
    'furniture',
    'gallery',
    'game',
    'game store',
    'gaming',
    'garage',
    'garden',
    'gatsby js',
    'gold',
    'google',
    'google adsense',
    'google classroom',
    'google maps',
    'government',
    'gpl license',
    'gradient',
    'graphic design',
    'graphic designer',
    'green',
    'grid',
    'grocery',
    'grocery store',
    'groupon',
    'gutenberg',
    'gym',
    'hacker',
    'hair salon',
    'handyman',
    'happy new year',
    'health coach',
    'healthcare',
    'help desk',
    'helpdesk',
    'hiking',
    'history',
    'holiday',
    'home decor',
    'horizontal scroll',
    'hospital',
    'hotel',
    'hotel booking',
    'hotel html',
    'house cleaning',
    'house rental',
    'html',
    'html css admin templates',
    'html cv',
    'html5',
    'hvac',
    'hyip',
    'ice cream',
    'image slider',
    'imdb',
    'industrial',
    'industry',
    'infinite scroll',
    'influencer',
    'instagram',
    'institute',
    'insurance',
    'insurance agency',
    'insurance company',
    'interactive',
    'interior design',
    'intranet',
    'inventory management',
    'investment',
    'invitation',
    'invoice',
    'ionic',
    'iot',
    'iptv',
    'islam',
    'islamic',
    'it consulting',
    'javascript',
    'jewellery',
    'jewelry',
    'job',
    'job board',
    'job listing',
    'job portal',
    'job posting',
    'job seeker',
    'journal',
    'jquery',
    'kendo ui',
    'kickstarter',
    'kids',
    'kids school',
    'kindergarten',
    'knowledge base',
    'laboratory',
    'landing page',
    'laptop repair',
    'laravel',
    'laravel admin',
    'laundry',
    'law',
    'law firm',
    'lawyer',
    'layerslider',
    'lazada',
    'lead generation',
    'learndash',
    'learning',
    'learning management system',
    'learnpress',
    'left menu',
    'library',
    'life coach',
    'lightweight',
    'limousine',
    'listing',
    'listing html',
    'live chat',
    'lms',
    'loan',
    'location',
    'login page',
    'logistic',
    'logistics',
    'logistics company',
    'logo',
    'logo design',
    'lyrics',
    'machinery',
    'magazine',
    'magento 2.3 theme',
    'magento2',
    'mailchimp',
    'maintenance',
    'manufacturing',
    'map',
    'market',
    'marketing agency',
    'marketplace',
    'masonry',
    'massage',
    'matchmaking',
    'material admin',
    'material design',
    'material ui',
    'mattress',
    'media',
    'medical',
    'medical dashboard',
    'medical store',
    'medicine',
    'medium',
    'mega menu',
    'membership',
    'menu',
    'messenger',
    'minimal',
    'minimal blog',
    'minimal portfolio',
    'minimal website',
    'minimalist',
    'mlm',
    'mobile',
    'mobile app',
    'mobile app design',
    'mobile app landing page',
    'mobile application',
    'mobile design',
    'mobile first',
    'mobile friendly blogger',
    'mobile html template',
    'mobile recharge',
    'mobile repair',
    'mobile template',
    'mobile ui',
    'mobile web app',
    'model agency',
    'modern',
    'modern blog',
    'money transfer',
    'monster',
    'mosque',
    'motorcycle',
    'movers',
    'movie',
    'movie review',
    'moving company',
    'mp3 player',
    'multi language',
    'multi page',
    'multi vendor',
    'multilingual',
    'multipurpose',
    'municipal',
    'museum',
    'music',
    'music app',
    'music band',
    'music player',
    'nature',
    'netflix',
    'neumorphic',
    'new year',
    'new york times',
    'news',
    'news portal',
    'newspaper',
    'next js',
    'ngo',
    'nodejs',
    'notification',
    'nutrition',
    'offers',
    'one page',
    'one page parallax',
    'one page portfolio',
    'onepage',
    'online booking',
    'online courses',
    'online education',
    'online food ordering',
    'online grocery shop',
    'online learning',
    'online magazine',
    'order confirmation',
    'organic',
    'organic food',
    'organization',
    'our team',
    'party',
    'payment',
    'personal blog',
    'personal portfolio',
    'personal profile',
    'personal trainer',
    'pest control',
    'pet shop',
    'pets',
    'pharmaceutical',
    'pharmacy',
    'phone repair',
    'photo gallery',
    'photo studio',
    'photobooth',
    'photography',
    'photography portfolio',
    'php',
    'physiotherapy',
    'pizza',
    'platform',
    'play school',
    'podcast',
    'popup',
    'portal',
    'portfolio',
    'pos',
    'pre-order',
    'preschool',
    'presentation',
    'price comparison',
    'pricing table',
    'product',
    'product catalog',
    'product design',
    'product landing page',
    'product page',
    'product showcase',
    'products',
    'professional',
    'profile',
    'programmer',
    'property',
    'psychologist',
    'psychology',
    'publisher',
    'pure',
    'pwa',
    'question and answer',
    'quiz',
    'quote',
    'radio',
    'radio station',
    'react',
    'react admin',
    'react chat',
    'react dashboard',
    'react ecommerce',
    'react food order',
    'react hooks',
    'react js',
    'react landing page',
    'react native',
    'react template',
    'reactjs',
    'reactstrap',
    'real estate',
    'recipe',
    'recruitment',
    'recycling',
    'red',
    'reddit',
    'registration form',
    'renovation',
    'rent a car',
    'rental',
    'repair',
    'reservation',
    'resort',
    'responsive',
    'responsive email template',
    'responsive html',
    'restaurant',
    'restaurant app',
    'resume',
    'retro',
    'review',
    'reviews',
    'revolution slider',
    'roofing',
    'rtl',
    'saas',
    'sales',
    'sales page',
    'sass',
    'schedule',
    'school',
    'search engine',
    'security',
    'security services',
    'sell',
    'sensei',
    'seo',
    'seo agency',
    'seo company',
    'seo friendly',
    'seo optimized',
    'seo plus',
    'seo website',
    'service',
    'service provider',
    'services',
    'shipping',
    'shipping company',
    'shoes',
    'shop',
    'shopify',
    'shopping',
    'shopping cart',
    'side menu',
    'signup',
    'simple',
    'simple blog',
    'simple dashboard html template',
    'single page',
    'single product',
    'single property',
    'skincare',
    'slick',
    'slider',
    'slider revolution',
    'soccer',
    'social media',
    'social media marketing',
    'social network',
    'software company',
    'solar',
    'solar energy',
    'spa',
    'space',
    'spiritual',
    'sport',
    'sports',
    'spotify',
    'startup',
    'static',
    'statistics',
    'stock market',
    'store',
    'storytelling',
    'studio',
    'subscription',
    'supermarket',
    'support',
    'survey',
    'svg',
    't-shirt',
    'tailwind',
    'takeaway',
    'tattoo',
    'taxi',
    'tea',
    'team',
    'tech',
    'tech blog',
    'telecom',
    'testimonial',
    'therapy',
    'threejs',
    'ticket',
    'ticket system',
    'tour',
    'tour booking',
    'tour operator',
    'tour package',
    'tourism',
    'tournament',
    'trading',
    'training',
    'training center',
    'transport',
    'travel',
    'travel agency',
    'travel blog',
    'travel guide',
    'tube',
    'tutorial',
    'tutorials',
    'tutoring',
    'tv',
    'twitter',
    'udemy',
    'ui',
    'ui design',
    'ui kit',
    'ui ux design',
    'uikit',
    'under maintenance',
    'university',
    'upwork',
    'user dashboard',
    'user profile',
    'ux design',
    'valentine',
    'vcard',
    'vegetables',
    'vendor',
    'vertical menu',
    'video',
    'video background',
    'video blog',
    'video blogging',
    'video call',
    'video conference',
    'video gallery',
    'video sharing',
    'video slider',
    'video website',
    'virtual business card',
    'vlog',
    'vue',
    'vue admin',
    'vue ecommerce',
    'vue js landing page',
    'vuejs',
    'vuetify',
    'wallet',
    'waste management',
    'watches',
    'water',
    'weather forecast',
    'web agency',
    'web app',
    'web application',
    'web design',
    'web design agency',
    'web designer',
    'web developer',
    'web development',
    'web development agency',
    'webapp',
    'webgl',
    'webinar',
    'webshop',
    'wedding invitation',
    'wedding photography',
    'wedding planner',
    'wellness',
    'whmcs',
    'wiki',
    'wine',
    'wireframe',
    'wood',
    'writer',
    'yacht',
    'yellow pages',
    'yoga',
    'youtube'
  ],
  [Site.graphicriver]: [
    '1 page resume',
    '16-bit',
    '16:9 banner',
    '16x16',
    '1800s',
    '1920x1080',
    '1930s',
    '1mg app',
    '2 page resume',
    '200x200',
    '2020 design trends',
    '2020 flyer',
    '20ft container',
    '21st',
    '24x7',
    '2d',
    '2d animation',
    '2d plan',
    '2d sprites',
    '2x3.5',
    '300 dpi',
    '32x32',
    '330ml',
    '355ml',
    '3d',
    '3d background generator',
    '3d book',
    '3d box generator',
    '3d builder',
    '3d crack',
    '3d flag',
    '3d flyer',
    '3d font',
    '3d laptop mockup',
    '3d logo design',
    '3d map',
    '3d poster mockup',
    '3d pricing table',
    '3d sublimation case',
    '3d text effect',
    '3d text mockup',
    '3g',
    '404 page',
    '"48x48,gif"',
    '4c',
    '4p',
    '4th of july',
    '5k wallpapers',
    '60s',
    '60s font',
    '7x7',
    '8 ball',
    '8 bit',
    '8-bit',
    '"8.5x11,colorful,design,modern,print ready,psd,simple"',
    '800x600',
    '80s',
    '8bit',
    '8d',
    '90s',
    '99 cents',
    '99 names of allah',
    'a direct hit',
    'a logo',
    'a3',
    'a380',
    'a4',
    'a4 brochure mockup',
    'a4 catalogue mockup',
    'a4 menu',
    'a4 portrait',
    'a4x3',
    'a5',
    'a5 brochure',
    'a5 menu',
    'a5 portfolio',
    'abstract',
    'abstract geometric collage',
    'ac flyer',
    'acai',
    'accents',
    'achiever',
    'acid',
    'actions',
    'activeden',
    'activewear',
    'add on',
    'admission open',
    'adobe camera raw presets',
    'adroll',
    'adroll banner set',
    '"ads,advert. popcorn,festival,night,scary,weekend"',
    'adventure',
    'advert',
    'advert mockup',
    'advertising',
    'advertorial',
    'advocate',
    'aegean',
    'affinity publisher',
    'afraid',
    'africa globe',
    'africa logo',
    'african mask',
    'afro',
    'after effect',
    'after effects',
    'afternoon tea',
    'agency deck',
    'agfa vista 400',
    'aims',
    'air conditioner',
    'airbag',
    'airborne',
    'airbus',
    'airbus a320',
    'airplane',
    'airpods',
    'airsoft team',
    'ak 47',
    'ak-47',
    'aladdin',
    'aladin',
    'album',
    'album art',
    'album art creator',
    'album cover template',
    'alcohol',
    'alexa',
    'alice in wonderland',
    'alien',
    'allday',
    'allergy',
    'almanac',
    'almond tree',
    'almonds',
    'alphabet',
    'altitude',
    'amazon mockup',
    'amazon product mockup',
    'ambience',
    'american express',
    'american idol',
    'amman',
    'amphora',
    'amstaff',
    'ancient',
    'android app',
    'angel wings',
    'angels and demons',
    'angry',
    'angry panda',
    'animal health logo',
    'animal illustrations',
    'animals',
    'animated',
    'animated gif',
    'animated google slides template',
    'animated mockup',
    'animation',
    'anime',
    'anime poster',
    'ankh',
    'anniversary',
    'anniversary album',
    'anniversary club',
    'announcement',
    'announcement icon',
    'announcements',
    'annual meeting',
    'annual report',
    'annual report word',
    'annunaki',
    'antidote',
    'ants',
    'anus',
    'app',
    'app billboard',
    'app google ad',
    'apple pages',
    'application',
    'appreciation',
    'appstore screenshots',
    'aquaculture',
    'arab',
    'arabesque',
    'arc de triomphe',
    'arcade mockup',
    'archangel',
    'architect',
    'architectural studio',
    'architecture',
    'architecture portfolio',
    'ares',
    'arise',
    'armageddon',
    'armor',
    'army',
    'arrange',
    'arrested',
    'art',
    'art expo brochure template',
    'articulated lorry',
    'artistic',
    'ash',
    'ashura',
    'asia',
    'asian food',
    'aspyn ovard',
    'asset',
    'assets',
    'asteria',
    'atlas',
    'attractions',
    'audio king logo',
    'augmented reality',
    'auto',
    'auto detailing',
    'auto parts',
    'auto repair',
    'auto rickshaw',
    'auto showroom',
    'automobile',
    'auxiliary',
    'avatar',
    'avengers',
    'axa',
    'ayurveda',
    'b logo',
    'b1 poster',
    'baby',
    'baby photo album',
    'baby shower flyer',
    'baby store',
    'baby toys',
    'bachata',
    'back to the future',
    'background',
    'backstage pass',
    'backyard',
    'badge',
    'badge mockup',
    'bag mock up',
    'bakery',
    'bakery logo',
    'bakery menu',
    'balanced scorecard',
    'bald',
    'bald eagle',
    'baldness',
    'baler',
    'ball',
    'ball mockup',
    'ballerina',
    'banana split',
    'bananas',
    'bandana',
    'banderole',
    'bando',
    'bangles',
    'banknote',
    'banned',
    'banners',
    'baobab',
    'bar mitzvah',
    'barbados',
    'barber shop',
    'barber shop flyer',
    'barbershop flyer',
    'baron',
    'barongsai',
    'barrel',
    'barrister',
    'baseball cap',
    'basketball court',
    'basketball player',
    'bat',
    'bathrobe',
    'bathroom accessories',
    'battleground',
    'bdsm',
    'beach bar uniform',
    'bean bag',
    'beast',
    'beatmaker',
    'beaueye',
    'beautiful sexy lady',
    'beauty',
    'beauty banner',
    'beauty business card',
    'beauty clinic flyer',
    'beauty salon banner',
    'beauty salon brochure',
    'beauty salon flyer',
    'bebop',
    'bed mock-up',
    'bedding set template',
    'bedding sheets',
    'bee logo',
    'beehive',
    'beekeeping',
    'beer menu',
    'beer mockup',
    'beer pong flyer',
    'beerpong',
    'belle epoque',
    'benefits',
    'best',
    'best buy',
    'best glamorous flyers',
    'best lightroom presets',
    'best pitch decks',
    'bestfont',
    'bholenath',
    'bi-fold',
    'bi-fold brochure',
    'bible prophecy',
    'big ben',
    'big booty',
    'big fake check',
    'bike',
    'billboard',
    'billboard design',
    'billfish',
    'billiard',
    'binder',
    'biodata',
    'biography',
    'biomass',
    'biometric',
    'bionics',
    'biopic',
    'biotech',
    'bird',
    'birthday',
    'birthday kids',
    'biryani',
    'bisnaga',
    'black',
    'black afrobeats',
    'black gold',
    'black market',
    'black panther',
    'blackboard',
    'blackjack',
    'blacksmith logo template',
    'blank',
    'blazer mockup',
    'blazon',
    'bleed',
    'blend',
    'blister card',
    'blister pack',
    'blockchain',
    'blogger presets',
    'blood',
    'blow dryer',
    'blue light',
    'bluebell',
    'blueprint mockup',
    'bluray',
    'bmw',
    'board game',
    'boarding pass',
    'boargame',
    'boat party',
    'boba',
    'bobsled',
    'body lotion',
    'bold studio',
    'bonnet',
    'book',
    'book cover template',
    'book stack',
    'book template',
    'booklet',
    'bookshelf',
    'bootstrap',
    'booty',
    'border',
    'botanica',
    'bottle',
    'boulder',
    'bounce house',
    'bourse',
    'boutique flyer',
    'boutique mockup',
    'box',
    'box mock-up',
    'box package',
    'box psd',
    'box template',
    'boxing fight',
    'boxing poster',
    'boy',
    'boy scout',
    'bradford',
    'brain logo',
    'brake disk',
    'branbook',
    'brand book',
    'brand guidelines',
    'brand kit',
    'brand manual',
    'branding',
    'branding pack',
    'bread',
    'breakfast',
    'breeze',
    'brickwall',
    'brickwork',
    'brochure',
    'brochure a4 landscape',
    'brochure mockup generator',
    'brooch',
    'brush',
    'brush script font',
    'brush strokes',
    'brushstroke',
    'btc',
    'bubble tea mockup',
    'bubblegum',
    'buckslip',
    'buddies',
    'buff',
    'buffalo wings',
    'buildbox',
    'builder',
    'builders brochure',
    'bull',
    'bull dog',
    'bull market',
    'bulldog',
    'bulldozer',
    'bullet',
    'bullets',
    'bullfrog',
    'bullseye brand',
    'bundle',
    'bungalow vector',
    'buraq',
    'burial',
    'burlesque show',
    'burner',
    'burritos',
    'bus',
    'bus mockup',
    'business',
    'business book',
    'business cd',
    'business newspaper',
    '"business pitch,delivery"',
    'business plan',
    'business plan template',
    'business proposal template',
    'butane',
    'butcher',
    'butcher flyer',
    'butler',
    'button',
    'buy gui',
    'buy online',
    'byzantine',
    'c64',
    'cafe',
    'cafe brochure',
    'cafe logo',
    'cafe mockup',
    'cafe racer',
    'cake flyer',
    'calendar',
    'calendar 2020',
    'call cards',
    'call out',
    'call-to-action',
    'calligraphy',
    'callout',
    'calvary',
    'camera raw',
    'camera raw presets',
    'campaign',
    'camper',
    'canada day flyer',
    'candidate',
    'candle jar',
    'candy crush',
    'canister',
    'cannabis',
    'cannibal',
    'canvas',
    'canvas mockup',
    'cap mockup',
    'capital letter',
    'capsule box',
    'car',
    'car ads',
    'car banner',
    'car branding',
    'car business card psd',
    'car industry',
    'car loan',
    'car marketplace',
    'car mats',
    'car mockup',
    'car page cover',
    'car paint',
    'car rent flyer',
    'car rental',
    'car rental banner',
    'car service',
    'car travels visiting card models',
    'car vector',
    'car wash',
    'car wash banner',
    'car wash billboard',
    'car washing app',
    'car wrap',
    'caravan',
    'carbon fibre',
    'card',
    'card castle',
    'card deck',
    'card game',
    'cards we moved',
    'caribbean menu',
    'caricature',
    'carlos viloria',
    'carousel',
    'cartoon',
    'cartoon book',
    'cartoon cock',
    'cartoon sun',
    'carved',
    'cascading',
    'case study',
    'cash memo',
    'casino',
    'casino night',
    'casting',
    'cat',
    'cat lover',
    'catalog',
    'catering brochure',
    'cbd',
    'ccg',
    'cctv',
    'cd cover template',
    'cdr flyer',
    'celebration',
    'cell',
    'celtic cross',
    'cent',
    'center seal pouch mockup',
    'central perk',
    'cereal box',
    'certificate',
    'certified',
    'chalk style photoshop',
    'chalkboard',
    'chalkboard generator',
    'champagne',
    'champion',
    'championship belt',
    'character bundle',
    'character pack',
    'character set',
    'character sprites',
    'characters',
    'charcoal',
    'charity',
    'charity for orphans flyer',
    'chart',
    'chatbot',
    'chef hat',
    'chef logo',
    'chemical icon',
    'cheque',
    'chess flyer',
    'chest',
    'chevy',
    'chicken bucket',
    'chicken flyer',
    'chicken wings',
    'child',
    'child doctor',
    'children and technology',
    'children play',
    'chillstep',
    'chinese dragon',
    'chinese lantern',
    'chips bag',
    'chirp',
    'chit chat',
    'chocolate box',
    'cholo',
    'chop',
    'christmas',
    'christmas web banner',
    'chroma',
    'chroma key',
    'chromatic aberration',
    'chrome',
    'chupacabra',
    'church',
    'church anniversary',
    'church banner',
    'church logo',
    'church poster',
    'churro',
    'cinema 4d',
    'circle',
    'circros logo',
    'circular font',
    'cistern',
    'city',
    'classmate',
    'clean',
    'clean ui',
    'cleaning banner',
    'cleaning business',
    'cleaning flyer',
    'clevery',
    'client proof',
    'climber',
    'clinic',
    'clipart',
    'closeup',
    'closeup sketchbook',
    'clothing',
    'clouds',
    'club',
    'club kids',
    'cms proposal',
    'coaster mockup',
    'coat mockup',
    'cocktail night',
    'cocktails flyer',
    'code',
    'code studio',
    'codecanyon',
    'coffee bag',
    'coffee mockup',
    'coffee presentation',
    'coin',
    'coke mockup',
    'collage',
    'collage flyer',
    'collection of digital marketing icons',
    'collection of real estate icons',
    'college prospectus',
    'colon',
    'color correction',
    'color festival',
    '"color grading,vogue"',
    'color palette',
    'color wheel',
    'colorize',
    'combat',
    'combo',
    'comic',
    'comic book photo',
    'comics book',
    'coming soon',
    'commando',
    'commercial',
    'commercial newsletter',
    'commercial use',
    'communication flyer',
    'communism',
    'communist',
    'compact disc',
    'company',
    'company pad',
    'company profile template',
    'comparative',
    'compendium',
    'competition',
    'complex',
    'complicated',
    'compliment slip',
    'compo',
    'computer',
    'comrade',
    'con',
    'concentric',
    'concert',
    'concert mockup',
    'concrete logo mockup',
    'concrete pump',
    'condom',
    'condom mockup',
    'conduit',
    'cone',
    'conference brochure',
    'conference flyer',
    'conference signage',
    'connected',
    'construction',
    'construction brochure',
    'construction flyer',
    'construction icons pack',
    'construction postcard',
    'construction proposal',
    'contact information',
    'content creator',
    'contextual',
    'contributor',
    'conversation',
    'converse',
    'convert photo to graffiti',
    'cookery',
    'cookie',
    'cookout flyer',
    'cooks',
    'cool',
    'cordial',
    'cordless drill',
    'corel draw infographics',
    'corel draw x4',
    'coreldraw',
    'cork board',
    'corkboard',
    'coronavirus',
    'corporate',
    'corporate envelope',
    'corporate rate card',
    'cortex',
    'cosmetic',
    'cosmetic vector',
    'cosmetics',
    'cossack',
    'couch potato',
    'countdown',
    'courier',
    'courier mockup',
    'course',
    'course ad',
    'course flyer',
    'cover',
    'coverflow',
    'covid-19',
    'covid19',
    'cowboy',
    'crack',
    'cracked',
    'craft bag',
    'crane bird logo',
    'cravat',
    'crazy mockup',
    'cream packaging',
    'create silhouette',
    'creative',
    'creative facebook banner',
    'creative fb cover',
    'creative market',
    'creative proforma',
    'creative sports magazine',
    'creative wall calendar',
    '"creative,design,elegant"',
    'creators',
    'creatox',
    'credentials',
    'creole',
    'crest',
    'cricket',
    'cricut',
    'cristal',
    'cristiano',
    'crocodile logo',
    'croquis',
    'cross stitch mockup',
    'crosshair',
    'crow',
    'crown logo',
    'crush',
    'crying',
    'crypto',
    'cryptocurrency',
    'crystal ball',
    'cs2',
    'csgo',
    'csh',
    'curd',
    'curly',
    'curly font',
    'cursive',
    'cursive fonts',
    'custom background',
    'custom flag',
    'custom shapes',
    'customer care',
    'customer satisfaction survey',
    'cut',
    'cute',
    'cutout',
    'cutting board',
    'cv',
    'cv template word',
    '"cv,professional,resume"',
    'cyber punk',
    'cyberpunk',
    'cyberpunk font',
    'cycles',
    'cyclist',
    'd',
    'd7',
    'dado font',
    'dafont',
    'dalmatian',
    'dance',
    'dance class',
    'dance studio',
    'dancehall',
    'dark',
    '"dark hdr,effects,hdr,lightroom,lightroom presets,pro,retro"',
    'dark moody',
    '"dark,gaming"',
    'dashboard',
    'datasheet',
    'dateline',
    'daytime',
    'death',
    'deck chair',
    'decorative',
    'decorative fonts',
    'defense',
    'deforestation',
    'delivery',
    'delivery man',
    'deluxe',
    'dental',
    'dental clipart',
    'dental floss',
    'dental flyer',
    'dental hygienist',
    'dental instagram',
    'derrick',
    'desert',
    'design',
    'design builder',
    'designer cv',
    'desktop application ui',
    'detergent',
    'detergent mockup',
    'detergent powder',
    'deutsch',
    'devices mockup',
    'devil',
    'diadem',
    'diagramm',
    'dialer',
    'diamond suit',
    'diarrhea',
    'diary',
    'dictionary',
    'dig',
    'digest',
    'digipak',
    'digital face',
    'digital shoping',
    'dingbat',
    'dino logo template',
    'dinosaur',
    'dionysus',
    'disc',
    'discount coupon',
    'dishwasher',
    'disinfectant',
    'disinfecting',
    'disk',
    'disney',
    'display',
    'disposable gloves',
    'disposable mask',
    'disposable medical mask',
    'distinction',
    'div',
    'diver',
    'dj',
    'dj banner',
    'dj battle party flyer',
    'dj booking',
    'dj press kit',
    'dj resume',
    'dj rider',
    'dl flyer',
    'dle',
    'dnb',
    '"dng presets,lightroom cc"',
    'doctor billboard',
    'doctor resume',
    'document',
    'dog',
    'dog collar',
    'dog food',
    'doll mockup',
    'doner',
    'doodle',
    'doodle icons',
    'door to door',
    'doorpost',
    'dope',
    'dossier',
    'dot',
    'double d',
    'double-glazing',
    'doughnut',
    'dover',
    'download',
    'download invoice template',
    'doypack',
    'dr seuss',
    'draft',
    'drag queen',
    'dragon',
    'dragon wings',
    'dragster',
    'drawing',
    'dreamer',
    'dress up',
    'drift',
    'drinks promotion',
    'drip',
    'driving school',
    'drone',
    'drone rent',
    'dropdown',
    'dropper mockup',
    'drum kit',
    'drumming',
    'dry fruits',
    'dry seal',
    'drywall',
    'duality',
    'duck gaming logo',
    'dump truck',
    'dungeon',
    'dvd label',
    'e letter logo',
    'e logo',
    'e-commerce',
    'e-liquid',
    'e-liquid bottle mock-up',
    'e-mail template',
    'e-sport mockup',
    'e-waste',
    'e65 envelope',
    'eagle logo',
    'earn money',
    'earn money online',
    'earning',
    'earth infographics',
    'eat',
    'ebay',
    'ebook cover',
    'ebook template',
    'eclectic',
    'eco',
    'eco clean',
    'ecommerce',
    'economy icon',
    'ecover',
    'edc',
    'edible',
    'editable',
    'editable portfolio',
    'editable triangle patterns',
    'edm cover',
    'edmonton',
    'edocument',
    'education banner',
    'edwardian',
    'effects',
    'efficiency icon',
    'egg mockup',
    'eguide',
    'eid al adha',
    'eid mubarak',
    'ekg',
    'el salvador',
    'elderly',
    'election',
    'election brochure template',
    'election flyer templates',
    'election poster template',
    'electric guitar',
    'electrical catalog',
    'electricity logo',
    'electron',
    'element',
    'elevator',
    'emboss',
    'embroidered logo mockup',
    'embroidered logo photoshop',
    'embroidery effect',
    'embroidery photoshop',
    'emoji',
    'emoticon',
    'employee handbook',
    'enclosed trailer',
    'endorsement',
    'endzone',
    'enema',
    'energy drink',
    'engine oil',
    'enmity',
    'enquiry',
    'envato',
    'eod',
    'epaper',
    'epic banner',
    'epk',
    'eps file',
    'epub',
    'erotic',
    'escher',
    'espn',
    'esport',
    'esport logo',
    'esports',
    'essential oils',
    'estimate',
    'etched',
    'ethnic',
    'eulogy',
    'europe',
    'european union',
    'evangelism flyer',
    'evanto',
    'event',
    'event announcement',
    'event mockup',
    'event organize',
    'event postcard',
    'evento',
    'evil',
    'ex',
    'exam app',
    'excel',
    'exchange rate',
    'exclamation',
    'exclusive',
    'executive summary',
    'exercise book',
    'exhibition mock-up',
    'exotic car flyer',
    'expert',
    'explanatory',
    'extreme',
    'eye care',
    'eyeball',
    'eyeliner',
    'f1',
    'fab lab',
    'face',
    'face mask',
    'facebook',
    'facebook business',
    'facebook cover',
    'facebook cover photo',
    'facebook post',
    'facebook post template',
    'facebook template',
    'factory',
    'falafel flyer',
    'family tree',
    'fanta',
    'fantasia',
    'fantasy',
    'fantasy badges',
    'fantasy rpg ui',
    'fantasy ui',
    'farm',
    'farm logo',
    'farmer market',
    'fashion',
    'fashion ad banner',
    'fashion calendar',
    'fashion catalog',
    'fashion flats',
    'fashion house',
    'fashion logo',
    'fashion mask',
    'fashion show flyer',
    'fashion slider',
    'fast food',
    'fast food banner',
    'fast food brochure',
    'fast food menu flyer psd',
    'fast racing',
    'fasting',
    'fathers',
    'fathers day flyer',
    'fb ads',
    'fb cover online store',
    'feather flag',
    'featured item',
    'fed up',
    'female chef',
    'feminine',
    'ferox',
    'ferrari',
    'fetal',
    'fever',
    'fibber',
    'fibre',
    'fifa',
    'fight club',
    'fight poster',
    'fighter',
    'figma',
    'filigree',
    'fillable pdf form',
    'fillers',
    'film',
    'film strip mockup',
    'film stroke',
    'filmstrip',
    'financing',
    'finder',
    'fingerboard',
    'fingernail',
    'fintech',
    'fir logo',
    'fire',
    'fire effect',
    'fire protection',
    'firefighter',
    'fish',
    'fish fry',
    'fish logo',
    'fishing',
    'fishing flyer',
    'fishy',
    'fitness',
    'fitness banner',
    'fitness logo',
    'fitness magazine covers',
    'flag mockup',
    'flagpole',
    'flappy bird',
    'flash',
    'flash back',
    'flash sale',
    'flashy',
    'flat',
    'flicker',
    'floor',
    'floor mockup',
    'floral',
    'florist',
    'flower logo',
    'flowers',
    'fluor',
    'fly',
    'fly-sheet',
    'flyer',
    'flyer sexy mami',
    'flyer sexy saturday',
    'flyers',
    'flyers party',
    'flying saucer',
    'flying squirrel',
    'fmcg',
    'folder icons',
    'followers',
    'font',
    'font bundles',
    'font pack',
    'fontfancy font',
    'food',
    'food business facebook cover',
    'food catalog',
    'food facebook',
    'food fest',
    'food festival',
    'food instagram',
    'food marketing',
    'food newsletter',
    'food packaging',
    'food poster',
    'foodpanda',
    'football',
    'football field',
    'football helmet',
    'football kit',
    'ford f-150 wrapping',
    'ford transit 2017',
    'forest',
    'forex',
    'formal',
    'formal shirt',
    'formal shirt psd mockup',
    'formula 1',
    'fortnite',
    'fox icon',
    'fps icons',
    'fracture',
    'frame',
    'frameworks',
    'france map',
    'frank lloyd wright',
    'free shipping badge',
    'freelance flyers',
    'freemium',
    'freeze',
    'french bulldog',
    'frequency',
    'fresh',
    'freshwater',
    'fried chicken flyer',
    'frog',
    'frog cartoon',
    'frosted glass',
    'fruit',
    'fruit vector',
    'fuel pump',
    'fugu',
    'fuji 400h lightroom presets download',
    'fun',
    'fun cartoon selfie',
    'funeral',
    'funfair',
    'furniture',
    'furniture ad banner',
    'furniture brochure',
    'furniture catalog',
    'furniture mockup',
    'future',
    'futuristic',
    'fx',
    'g logo',
    'g-string',
    'ga',
    'gaelic',
    'gallon',
    'gallows',
    'gambling',
    'game',
    'game banner',
    'game effect',
    'game icons',
    'game obstacles',
    'game of thrones',
    'game reskin',
    'game title',
    'gameday',
    'gamer banner',
    'gamer logo',
    'gaming',
    'gaming avatar',
    'gaming banner',
    'gaming flyer',
    'gaming jersey',
    'gaming tshirt',
    'ganesh',
    'ganesha',
    'gang',
    'gang leader',
    'ganja',
    'ganpati',
    'garden brochure',
    'garden care',
    'garden flyer',
    'gardening logo',
    'garuda',
    'gas',
    'gas mask',
    'gate pass templates',
    'gazebo mockup',
    'geek mascot',
    'gelatin',
    'gem text',
    'gemstone',
    'generator',
    'geographic',
    'geometric art',
    'gesture',
    'gfx',
    'ghost hunting',
    'giallo',
    'giant',
    'gif',
    'gift',
    'gift shop',
    'gimp',
    'girl',
    'glam flyer',
    'glamour',
    'glass jar packaging',
    'glassful',
    'glaze',
    'glossy web 2.0',
    'gloves mockup',
    'glow text',
    'goal thermometer',
    'goat logo',
    'gold metallic gold palette',
    'gold text',
    'golden ticket',
    'golem',
    'golf banner',
    'golf club uniform',
    'golf flyer bundle',
    'golf poster',
    'golf scores',
    'good cv',
    'google adwords banner',
    'google maps',
    'google slids',
    'google web designer banner',
    'googleside',
    'gorilla',
    'gorilla vector',
    'gospel concert flyer',
    'gospel poster',
    'gospel template',
    'gossip magazine template',
    'got milk',
    'gothic',
    'gothic font',
    'gourmet',
    'grabbing',
    'gradient',
    'gradient map',
    'gradient ppt',
    'graduation ceremony',
    'graffiti',
    'graffiti business card',
    'graffiti font',
    'graffiti styles',
    'grain',
    'grammy awards',
    'grand opening',
    'graph',
    'graphic',
    'graphic artist',
    'graphicer',
    '"graphics,powerpoint"',
    'graphilker',
    'grass',
    'grass letters',
    'grasshopper',
    'gravel',
    'graze',
    'great white shark',
    'green food flyer',
    'green screen',
    'green tosca',
    'greengrocer',
    'greenleaf',
    'grenade',
    'grids',
    'grinder',
    'groomer',
    'grovel',
    'growler',
    'grub',
    'grunge menu',
    'gslide',
    'gta',
    'guangdong',
    'guest house',
    'gui',
    'guilloche',
    'gum pack',
    'gummy',
    'gun',
    'gunner',
    'gym',
    'gym ads',
    'gym banner',
    'gym mockup',
    'gym voucher',
    'h logo',
    'hachiko',
    'hack',
    'hacker',
    'hadrosaur',
    'hag',
    'hair salon',
    'hair salon flyer',
    'hair spray',
    'hajj',
    'half zip jacket',
    'hand fan mockup',
    'hand gestures',
    'hand poke',
    'hand-cream',
    'handout',
    'handwriting',
    'hang tag',
    'hannya',
    'happy',
    'happy birthday wallpaper',
    'happy janmashtami',
    'hardhat',
    'hardware store',
    'hardware vector icons',
    'hash',
    'hat',
    'haweya studio',
    'hawk',
    'hazmat suit',
    'header',
    'headline',
    'headrest',
    'headstone',
    'health bar',
    'health logo',
    'healthcare',
    'healthcare flyer',
    'healthy',
    'heart mockup',
    'heavy metal magazine',
    'hedwig',
    'helmet',
    'hemisphere',
    'hemp sheet',
    'heraldry',
    'hero',
    'hexa pixel',
    'hexagon logo',
    'hi-tech ui',
    'high def',
    'hiking',
    'hillbilly',
    'hillsong',
    'hip hop',
    'hiphop flyer',
    'hipster logo',
    'hire',
    'hockey helmet',
    'hockey poster',
    'holi flyer',
    'hong bao',
    'hongkong',
    'hookah',
    'hookah event',
    'hookah flyer',
    'hookah lounge flyer',
    'hookah setup',
    'horizontal rule',
    'horror',
    'hortensia',
    'hospice',
    'hospital',
    'hospital banner',
    'hospital flyer',
    'hostel',
    'hotel banners',
    'hotel brochure',
    'hotel indesign template',
    'hotel key card',
    'hotspot',
    'house cleaning ad',
    'house paint',
    'html invoice',
    'html5',
    'hud',
    'hud ui',
    'hudson hornet',
    'huji cam',
    'hula hoop',
    'human kidney',
    'human resources',
    'hush',
    'hustle',
    'hvac',
    'hydrangea',
    'hydro',
    'hydroponic',
    'hypebeast',
    'hypermarket',
    'i love you 3000',
    'iaas',
    'icbm',
    'ice',
    'ice cream',
    'ice cream flyer',
    'ice cream mockup',
    'ice lolly',
    'ice styles',
    'icicle',
    'icon',
    'icon pack',
    'id',
    'idul fitri',
    'ig',
    'illuminati',
    'illustrator',
    'illustrator proposal',
    'image',
    'income tax flyer template',
    'indesign',
    'indesign architecture portfolio',
    'indesign checklist',
    'indesign form template',
    'indesign newspaper',
    'indesign photobook',
    'indesign proposal',
    'indesign questionnaire template',
    'indesign quote template',
    'indesign survey template',
    'india map',
    'indian restaurant',
    'infochart',
    'infographic',
    'insect',
    'insta font',
    'instafonts',
    'instagram',
    'instagram banners',
    '"instagram filter,lightroom presets"',
    'instagram grid',
    'instagram grid posts',
    'instagram mockup',
    'instagram pack',
    'instagram post template',
    'instagram presets',
    'instagram puzzle',
    'instagram stories',
    'insurance flyer',
    'interactive pdf',
    'interior mockup',
    'internet cafe',
    'investment brochure',
    'investor',
    'invoice',
    'ipad ui',
    'iphone',
    'iphone 11',
    'iphone x mockup',
    '"iphone,sublimation template. sublimation size"',
    'iptv',
    'islamic',
    'islamic flyer',
    'isometric',
    'itunes',
    'jack daniels',
    'jaden smith',
    'japan',
    'japanese',
    'jav',
    'jet',
    'jetski',
    'jewelry box',
    'jotter',
    'juice',
    'juice menu',
    'jumpsuit',
    'jungle',
    'k logo',
    'kabala',
    'kabbalah',
    'kebab',
    'key visual',
    'keynote',
    'keynote templates',
    'keywords',
    'kid',
    'kiosk',
    'kodak',
    'kurta',
    'lab',
    'label',
    'label design',
    'lampshade mockup',
    'land surveyor business card',
    'laptop flyer',
    'laundry app android psd',
    'laundry banner',
    'laundry business card',
    'laundry flyer',
    'lava',
    'lawyer',
    'layout',
    'leaderboard',
    'league of legends text style',
    'letterhead',
    'letterhead design',
    'light',
    'lightning',
    'limbo',
    'lion',
    'lip gloss',
    'littering',
    'live streaming',
    'liver',
    'lo-fi',
    'locksmith',
    'login',
    'logistic brochure',
    'logo',
    'logo animation',
    'logo badge',
    'logo enhancer',
    'logo font',
    'logo pack',
    'logo portfolio',
    'logo preview',
    'lotto',
    'lower third',
    'lowrider',
    'lpg',
    'ludo',
    'lunch',
    'lut',
    'm logo',
    'm4a1',
    'mac pages',
    'madden',
    'magazine',
    'makeup artist',
    'manual',
    'map',
    'map mockup',
    'mark sheet template',
    'marketing',
    'marketing kit',
    'marketplace',
    'marquee',
    'marriage dvd cover',
    'martial arts flyer',
    'marvel',
    'masala',
    'mascot',
    'mascot generator',
    'mastercard',
    'match 3',
    'matchday',
    'material design presentation',
    'medal',
    'media pass',
    'medical banner',
    'medical face mask',
    'medical marijuana',
    'medical mask',
    'medical stationary',
    'medicine box design',
    'medieval',
    'medieval ui',
    'mega pack',
    'mehndi',
    'menu',
    'menu board',
    'mexican',
    'microsoft',
    'microsoft word',
    'milestone',
    'military mockup',
    'milkshake',
    '"mind map,mockup"',
    'minecraft',
    'minimal letterhead',
    'minimalist',
    'minimalist logo',
    'mixcloud',
    'mixtape',
    'mixtape album covers psd',
    'mixtape cover',
    'mixtape cover psd file',
    'mixtape psd',
    'mma flyer',
    'mmo',
    'mmo ui',
    'mmorpg',
    'mmorpg ui',
    'moba',
    'mobile app',
    'mobile legend logo',
    'mobile repair',
    'mockup',
    'mockup slides',
    'mocup',
    'modern',
    'modern newsletter',
    'money',
    'monthly',
    'moo',
    'moodboard',
    'mothers day',
    'motocross flyer',
    'motor club',
    'motorcycle',
    'motorhome',
    'mountain bike',
    'movie poster credits template',
    'movie psd',
    'movie ticket',
    'mtb',
    'mtg',
    'mug mockup',
    'mugshot',
    'mugshot generator',
    'multipage newsletter',
    'mural',
    'mushrooms types',
    'music',
    'music dj banner',
    'music producer',
    'music promo',
    'music torrent',
    'music video flyer',
    'nail art',
    'nails logo',
    'nameplate',
    'namkeen',
    'nascar',
    'nasi lemak',
    'nature',
    'nautical',
    'necker',
    'necklace mock-up',
    'neon',
    'neon light',
    'neon sign',
    'netflix',
    'newspaper',
    'newspaper ad',
    'newspaper advert',
    'newspaper template',
    'nfl',
    'ngo',
    'nightclub',
    'ninja',
    'notice board',
    'noticeboard',
    'nude',
    'obituary',
    'obs',
    'occult',
    'office',
    'office mockup',
    'oil barrel',
    'oil paint plugin',
    'old',
    'old computer mockup',
    'one page calendar',
    'oni',
    'online shop logo',
    'opentype',
    'organic',
    'outrun',
    'p logo',
    'packaging',
    'pacman',
    'pamphlet',
    'pandemic',
    'party',
    'pastor birthday',
    'pattern mockup',
    'pc case',
    'pc repair',
    'pdf',
    'pear of anguish',
    'pencil logo',
    'perfume',
    'perfume box',
    'periodic table',
    'personal portfolio powerpoint template',
    'pest control',
    'pet',
    'pet shop',
    'peugeot',
    'pharmacy flyer',
    'phoenix logo',
    'phone repair',
    'photo',
    'photobook',
    'photoshop',
    'photoshop animation',
    'photoshop overlays',
    'photoshop proposal',
    'php',
    'pillow mockup',
    'pitbull',
    'pitch deck',
    'pitchdeck',
    'pixel art',
    'pixel lab',
    'pixelmator',
    'pizza box',
    'pizza menu flyer',
    'plane',
    'plaque',
    'plastic',
    'plastic bag',
    'platformer',
    'playboy',
    'playing cards',
    'plot sell flyer',
    'plumber',
    'podcast',
    'podcast cover',
    'podium mockup',
    'point of sale',
    'pokemon',
    'poker card mockup',
    'poker flyer',
    'poker game assets',
    'poker psd',
    'poker table',
    'poker ui',
    'police car',
    'poly mailer bags',
    'pomade',
    'pop art',
    'pop-up',
    'portfolio',
    'portrait',
    'pos',
    'postcard',
    'posters',
    'potato chip',
    'pouch',
    'poultry logo template',
    'powerpoint',
    'ppe',
    'ppt',
    'pralines',
    'prayer meeting',
    'premier league',
    'premium',
    'presentation',
    'preset',
    'presidential election',
    'press release',
    'pressure washing',
    'pricing list',
    'pricing table',
    'print on demand',
    'print ready',
    'printer mockup',
    'printing press flyer',
    'pro 3d mockup',
    'product',
    'product flyer psd template',
    'professional',
    'professional mockup',
    'project proposal template',
    'project report',
    'promotion',
    'propaganda',
    'property banner',
    'proposal',
    'prospectus template',
    'protein bar',
    'protest',
    'prototype',
    'psd',
    'psd gold',
    'pubg',
    'puma mock-up',
    'punjabi',
    'puzzle',
    'quarantine',
    'quilt',
    'quiz',
    'quran',
    'r logo',
    'rabbit',
    'race',
    'race flyer',
    'radio cover',
    'radiology',
    'raincoat',
    'rakhi',
    'rakshabandhan',
    'ramadan',
    'ramadan flyer',
    'ramen',
    'ramen menu',
    'rank',
    'ranks',
    'rap cover',
    'rdx',
    'ready made',
    'real estate',
    'real estate banner',
    'real estate billboard',
    'real estate brochure',
    'real estate magazine',
    'real estate mockup',
    'realistic',
    'realistic lightroom preset',
    'receipt mockup',
    'recommendation letter',
    'remote control',
    'report',
    'report mockup',
    'restaurant',
    'restaurant banner',
    'restaurant facebook cover',
    'restaurant menu design',
    'retro',
    'retro gaming',
    '"retro,retrowave"',
    'retrowave',
    'review',
    'revival',
    'ribbon',
    'ribbon mockup',
    'ring mockup',
    'ripped paper',
    'rivet',
    'robe',
    'rock',
    'roll-up',
    'roll-up banner',
    'rollercoaster',
    'romantic',
    'roofing',
    'rose gold',
    'rounded',
    'royal',
    'royal king logo',
    'rpg',
    'rpg ui',
    'rts',
    'rubber stamp',
    'rug mockup',
    'rusk packaging',
    's',
    'sachet',
    'saddle stitch',
    'sagittarius',
    'sale',
    'sale mockup',
    'sales funnel',
    'salon billboard',
    'salsa flyer',
    'sam kolder',
    'samurai',
    'sandblaster',
    'sans',
    'saree',
    'satanic',
    'sauce label',
    'save the date',
    'scandinavian',
    'scene builder',
    'scene creator',
    'scene generator',
    'scholarship flyer',
    'school prospectus',
    'school uniform',
    'sci-fi ui',
    'scifi',
    'scoreboard',
    'scrabble',
    'screen',
    'script',
    'scroll',
    'scrub suit',
    'seafarer',
    'seafood flyer',
    'seal',
    'seaman',
    'security',
    'security cameras',
    'sell',
    'semi-truck',
    'seminar poster',
    'sewing machine',
    'sexy',
    'shape',
    'shawarma',
    'shipping',
    'shisha',
    'shiva',
    'shoe box',
    'shoelace',
    'shogun',
    'shopping bag',
    'shopping logo',
    'showreel',
    'sign up',
    'signature',
    'signboard',
    'signpost',
    'sim card',
    'simple',
    'simplus',
    'sketch',
    'slideshow',
    'slot machine',
    'smart home',
    'smartwatch',
    'smm',
    'smudge painting',
    'snapchat',
    'soap',
    'soca',
    'social media',
    'social media kit',
    'social media pack',
    'software box',
    'solar energy',
    'solar panel',
    'sound',
    'souvenir book',
    'soviet',
    'space invaders',
    'speaker flyer',
    'speedometer',
    'spice box',
    'sponsorship',
    'sport',
    'sport banner',
    'spotify',
    'sprite',
    'sprite sheet',
    'spy',
    'square flyer',
    'square portfolio',
    'squarespace',
    'ss',
    'stamp generator',
    'stand-up pouch',
    'standee',
    'star wars',
    'startup',
    'startup pitch deck',
    'stay at home',
    'steampunk',
    'store',
    'straight outta compton',
    'streetwear',
    'strip club',
    'stylish',
    'stylistic',
    'sublimation',
    'subscription',
    'subscription box',
    'subtitle',
    'suicide squad',
    'superhero',
    'supermarket',
    'supermarket flyer',
    'supplement',
    'sushi menu',
    'susu',
    'swag',
    'symbol',
    'synthwave',
    't-shirt',
    't-shirt design',
    't-shirt esport',
    'table',
    'table calendar',
    'table tennis',
    'tablet mockup',
    'tablet ui',
    'tablo',
    'tag',
    'tailor',
    'tailoring',
    'takoyaki',
    'talk show',
    'tamplet',
    'taxi visiting card',
    'tcg',
    'tea bag',
    'teal',
    'telemedicine',
    'template',
    '"template,whatsapp"',
    'tetris',
    'text',
    'theater marquee sign',
    'theme',
    'theme park',
    'thesis',
    'three little pigs',
    'ticker',
    'tiktok',
    'tilemap',
    'tileset',
    'timeline psd',
    'tinder',
    'title',
    'tokyo',
    'tomorrowland',
    'top down',
    'torrent',
    'tote',
    'totem pole',
    'tournament',
    'tow truck',
    'tower defense',
    'toyota hilux mockup',
    'tracksuit',
    'tradeshow',
    'trading card',
    'tram mockup',
    'transparent business card',
    'travel agency catalog',
    'travel icon set',
    'treasure map',
    'trend',
    'tri-fold',
    'tribal',
    'trifold menu',
    'trophy',
    'tuition',
    'tv',
    'typography',
    'uber',
    'ufc fight',
    'ufc flyer',
    'ufc poster',
    'ui',
    'ui kit',
    'umrah',
    'underwear',
    'uniform',
    'universal',
    'university',
    'university flyer',
    'unlimited',
    'upload',
    'urban',
    'urban clap',
    'user manual',
    'van mockup',
    'vape',
    'vaping',
    'vaporwave',
    'vector',
    'vector car',
    'vectornator',
    'vegan',
    'vending machine',
    'vendor',
    'vertical',
    'vexel',
    'vfx',
    'vhs',
    'vhs cover',
    'video',
    'video call app',
    'videographer',
    'videohive',
    'vignette',
    'vintage',
    'vinyl',
    'vip',
    'virtual reality',
    'virus',
    'visor',
    'visual identity',
    'vk.com',
    'vlog',
    'vlogger',
    'vpn',
    'vr',
    'vsco',
    'vsco filters',
    'vsco presets',
    'w logo',
    'wall chart',
    'wallpaper',
    'warship',
    'warthog',
    'watermark',
    'wax seal',
    'wax stamp generator',
    'wayang kulit',
    'web',
    'web design flyer',
    'web design proposal',
    'website showcase mockup',
    'website template',
    'wechat',
    'wedding',
    'wedding dvd psd',
    'welder',
    'western',
    'wet wipes',
    'whatsapp',
    'whatsapp clone',
    'whatsapp flyer',
    'whey protein',
    'white',
    'white paper',
    'windbreaker',
    'wing',
    'wizard',
    'wolf',
    'wolf logo',
    'woman',
    'wood',
    'wordpress',
    'worship flyer',
    'wraith',
    'wrestling',
    'written',
    'wwe',
    'xxx',
    'yearbook',
    'yoga flyer',
    'youtube',
    'youtube cover',
    'youtube psd',
    'z-card',
    'zen',
    'zeppelin',
    'ziploc bag',
    'zodiac signs',
    'zombie cartoon',
    'zoom'
  ]
}

const processedParamsForSite: { [site: string]: INoIndexParams[] } = {}

const noIndexAllowList = (
  { site, routes, params }: INoIndexAllowList,
  tagsBySite: AllowedTagsBySite = allAllowedTagsBySite
) => {
  if (processedParamsForSite[site] === undefined) {
    const allowedTagsBySite = tagsBySite[site] || []

    processedParamsForSite[site] = allowedTagsBySite.map(tag => ({
      name: 'tags',
      value: tag
    }))
  }

  return {
    routes: routes.concat([]),
    params: processedParamsForSite[site].concat(params)
  }
}

export default noIndexAllowList
